module.exports = __webpack_public_path__ + "img/background6.9aa80451.jpg";